import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import store from '../../../store';
import { Message, Loading } from 'element-ui';
// 响应时间
axios.defaults.timeout = 80* 1000
// 配置cookie
axios.defaults.withCredentials = false;
// axios.defaults.withCredentials = true
// 配置请求头
// axios.defaults.setHeader("Access-Control-Allow-Origin", "*");
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Client-Platform'] = 'web';
axios.defaults.headers.get['Client-Platform'] = 'web';
axios.defaults.headers.put['Client-Platform'] = 'web';
// 静态资源
Vue.prototype.$static = ''
function ser(obj) {
  var ne = {};
  for (var i in obj) {
    ne[ i] = obj[i];
  }
  return ne;
};
console.log('process.env.NODE_ENV', process.env.NODE_ENV)
// 配置接口地址
  axios.defaults.baseURL = process.env.NODE_ENV == 'development' ? "/api/" : 'https://yingcaiapi.yingcaiyuanfu.com/api/'
  // axios.defaults.baseURL="/api/"
//   axios.defaults.baseURL = 'http://10.0.0.184:8789'
// var loadingInstance
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
  config => {
    config.headers['Token'] = !!store.state.loginInfo.Token ? store.state.loginInfo.Token : ''
    // console.log(config);
    if(config.requestBase == 'mobile') {
      // if ((store.state.mobileToken || sessionStorage.getItem('mobileToken')) == null) {
      //   // Message({showClose:true,message:'请重新登录',type:"error"});
      // }
      config.headers['Token'] = (store.state.mobileToken || sessionStorage.getItem('mobileToken')) || ''
      config.baseURL = process.env.NODE_ENV ==  'development' ? "/api2/" : 'https://yingcaimobile.yingcaiyuanfu.com/api/'
      // config.baseURL = "/api2/"
    }
    if(config.method==='get'){
      config.params={
        // pageIndex:config.params.pageIndex||1,
        // PageSize:config.params.pageSize||20,
        // operater:UserInfo.UserInfo.Account,
        // operaterID:UserInfo.UserInfo.UserId,
        ...ser(config.params)
      }
    }
    return config
  },
  err => {
    Message({showClose:true,message:'请求错误',type:"error"});
    return;
    //Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    if (res.data.Code == 200) {
      return res.data;
    } else if (res.config.url == 'Member/v1/checkscene') {
      if (res.data.Code == 200 || res.data.Code == 201) {
        return res.data;
      }
    } else {
      if (res.data.Code == '10010') {
        return res.data;
      } else {
        if (res.data.Code == '401') {
          store.commit('changeShowLoginState', true)
        } else {
          Message({showClose:true,message:res.data.Msg,type:"error"});
        }
      }
      // this.$message.error(res.data.Msg)
    }
  },
  err => {
    // this.$message.error(err.data.Msg)
    Message({showClose:true,message:err.data.Msg,type:"error"});
  }
)

// 发送请求
export function Post (url, params,login) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        res => {
          resolve(res)
          // Promise.reject(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
// 发送put请求
export function Put (url, params) {
  return new Promise((resolve,reject) => {
    axios
      .put(url, params)
      .then(
        res => {
          // console.log(url)
          resolve(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
// 发送delete请求
export function Delete (url, params) {
  
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then(
        res => {
          resolve(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
export function Get (url,params){
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params: params
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
}
export function Get2 (url,params){
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        requestBase: 'mobile'
      })
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export function Post2 (url, params,login) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {requestBase: 'mobile'})
      .then(
        res => {
          resolve(res)
          // Promise.reject(res)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}


// WEBPACK FOOTER //
// ./src/assets/common/js/https.js